import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import CustomFormField from "components/CustomFormField";
import { connect } from "react-redux";

const OrganizationForm = ({ formData, localizations }) => {
  const {
    formField,
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    setFieldValue,
    setFieldTouched,
  } = formData;

  const {
    organizationKey: { errorMsg: _organizationKey, ...organizationKeyRest },
    isPhonicsEnabled: { errorMsg: _isPhonicsEnabled, ...isPhonicsEnabledRest },
  } = formField;

  const { organizationKey: organizationKeyV, isPhonicsEnabled: isPhonicsEnabledV } = values;

  return (
    <>
      <SuiTypography variant="h5">
        {localizations?.ORGANIZATION_FORM_HEADER ?? "Organizasyon Genel Detayları"}
      </SuiTypography>
      <SuiBox mt={1} mb={5}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={4}>
            <CustomFormField
              {...organizationKeyRest}
              value={organizationKeyV}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors?.description?.length > 0 && touched?.description}
              success={organizationKeyV.length > 0 && !errors?.description}
            />
          </Grid>
          <Grid item xs={12} lg={4}>
            <CustomFormField
              {...isPhonicsEnabledRest}
              type="switch"
              value={isPhonicsEnabledV}
              label={localizations?.ORGANIZATION_FORM_PHONICS_LABEL ?? "Phonics Enable"}
              setFieldValue={setFieldValue}
              setFieldTouched={setFieldTouched}
            />
          </Grid>
        </Grid>
      </SuiBox>
    </>
  );
};

OrganizationForm.defaultProps = {
  localizations: null,
};

OrganizationForm.propTypes = {
  formData: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
  localizations: PropTypes.objectOf(PropTypes.any),
};

const mapStateToProps = (state) => ({
  localizations: state.localization?.pairs,
});

export default connect(mapStateToProps, null)(OrganizationForm);
